import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

/* One person or vehicle, as the business unit asks it (data.AccreditationField).

   The fields come from the server in display order with their type; a file field opens the
   phone's camera or files. Submits multipart so a scan travels with the text. `initial` is
   the row as the API serves it: values by key, a file as {name, url}. */
const AccreditationForm = ({ fields, initial, onSubmit, onCancel, busy, submitLabel }) => {
  const { t } = useTranslation();
  const [values, setValues] = useState(() => {
    const out = {};
    (fields || []).forEach((f) => {
      if (f.type === 'file') return;
      out[f.key] = (initial && initial.values && initial.values[f.key]) || '';
    });
    return out;
  });
  const [files, setFiles] = useState({});

  const submit = (e) => {
    e.preventDefault();
    const form = new FormData();
    if (initial && initial.id) form.append('id', initial.id);
    Object.entries(values).forEach(([k, v]) => form.append(k, v || ''));
    Object.entries(files).forEach(([k, file]) => { if (file) form.append(k, file); });
    onSubmit(form);
  };

  return (
    <form className="ops-form" onSubmit={submit}>
      {(fields || []).map((f) => {
        const current = initial && initial.values ? initial.values[f.key] : null;
        const label = `${f.label}${f.required ? ' *' : ''}`;
        if (f.type === 'file') {
          return (
            <label key={f.key} className="ops-field">
              <span className="ops-field__label">{label}</span>
              {current && current.url && (
                <a href={current.url} target="_blank" rel="noreferrer" className="ops-field__file">
                  {current.name || t('opsViewFile')}
                </a>
              )}
              <input type="file" accept="image/*,application/pdf"
                     onChange={(e) => setFiles({ ...files, [f.key]: e.target.files[0] })} />
            </label>
          );
        }
        if (f.type === 'select') {
          return (
            <label key={f.key} className="ops-field">
              <span className="ops-field__label">{label}</span>
              <select value={values[f.key]} onChange={(e) => setValues({ ...values, [f.key]: e.target.value })}>
                <option value="">—</option>
                {f.options.map((o) => <option key={o} value={o}>{o}</option>)}
              </select>
            </label>
          );
        }
        const type = { date: 'date', number: 'number', phone: 'tel' }[f.type] || 'text';
        return (
          <label key={f.key} className="ops-field">
            <span className="ops-field__label">{label}</span>
            <input type={type} value={values[f.key]}
                   onChange={(e) => setValues({ ...values, [f.key]: e.target.value })} />
          </label>
        );
      })}
      <div className="ops-form__actions">
        {onCancel && (
          <button type="button" className="ops-btn ops-btn--ghost" onClick={onCancel} disabled={busy}>
            {t('cancel')}
          </button>
        )}
        <button type="submit" className="ops-btn" disabled={busy}>{submitLabel || t('save')}</button>
      </div>
    </form>
  );
};

export default AccreditationForm;
